
// TEMP: Extend scope with fn and dom library functions
import 'literal/scope.js';
import Literal                    from 'literal/module.js';
import select                     from 'dom/select.js';
import { open, close, toggle }    from 'bolt/attributes/name=toggle.js';
import cart, { requestCart, requestPatchCart } from '../models/cart.js';
import products, { requestFont, requestCustom } from '../models/products.js';
import { showMessage }            from '../../messages/module.js';
import Stream                     from 'fn/stream.js';
const assign = Object.assign;
const { quantityFactors, contractorFactors } = window.config;

// Currency display
const locale    = navigator.languages || navigator.language || 'en-GB';
const formatter = new Intl.NumberFormat(locale, { style: 'decimal', maximumFractionDigits: 0 });

function formatPrice(n) {
    return formatter.format(n);
}

assign(Literal.scope, {
    // Element actions
    open,
    close,
    toggle,
    showMessage,

    // Objects
    cart,
    products,

    // Functions
    select,
    requestCart,
    requestPatchCart,
    requestFont,
    requestCustom,
    formatPrice,

    Stream,

    calcPrice: (quantity, contractor, n) => {
        const factor = quantityFactors[quantity] + (contractor ? contractorFactors[quantity] : 0);
        return Math.floor(factor * n);
    }
});
